export const FETCH_PRICE_GROUPS_LIST_REQUEST = "FETCH_PRICE_GROUPS_LIST_REQUEST";
export const FETCH_PRICE_GROUPS_LIST_SUCCESS = "FETCH_PRICE_GROUPS_LIST_SUCCESS";
export const FETCH_PRICE_GROUPS_LIST_FAILURE = "FETCH_PRICE_GROUPS_LIST_FAILURE";
